<template>
  <vx-card class="mt-base" title="Ozopay account info" no-shadow card-border>
    <div class="pl-3 pr-3 vx-row">
      <div class="w-full mt-5">
        <label class="text-sm"
          ><span class="text-error">*</span> Merchant ID</label
        >
        <vs-input
          v-model="form.accountId"
          class="w-full"
          name="name"
          v-validate="'required'"
        />
        <span class="text-sm text-danger" v-show="errors.has('accountId')">{{
          errors.first('accountId')
        }}</span>
      </div>
      <div class="w-full mt-5">
        <label class="text-sm"
          ><span class="text-error">*</span> Merchant Secret</label
        >
        <vs-input
          v-model="form.key"
          class="w-full"
          name="name"
          v-validate="'required'"
        />
        <span class="text-sm text-danger" v-show="errors.has('key')">{{
          errors.first('key')
        }}</span>
      </div>
    </div>
    <vs-button
      color="success"
      class="flex flex-wrap-reverse justify-end flex-grow mt-6 mb-3 mr-3"
    >
      <div @click="verify">Verify</div>
    </vs-button>
  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.form = this.data
  },
  methods: {
    async verify() {
      let result = await this.$validator.validateAll()

      if (!result) {
        return
      }

      this.$emit('change', this.form)
    },
  },
  data() {
    return {
      form: {
        key: null,
        accountId: null,
      },
    }
  },
}
</script>
